/**
 * Лёгкий сигнал «импорт из Notion начался». Плашка импорта (и тяжёлый редактор за ней) грузится только после него,
 * а не при каждом открытии Chat.
 */
let started = false;
const listeners = new Set<() => void>();

export const importAnnounced = (): boolean => started;
export const subscribeImportAnnounced = (l: () => void) => {
  listeners.add(l);
  return () => {
    listeners.delete(l);
  };
};
export function announceImport(): void {
  if (started) return;
  started = true;
  for (const l of listeners) l();
}
